
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../vue-loader/lib/style-rewriter?id=data-v-fdcbdf94&scoped=true!../../../vue-loader/lib/selector?type=styles&index=0!./CustomTransition.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./CustomTransition.vue"),
  /* template */
  null,
  /* scopeId */
  "data-v-fdcbdf94",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/v-calendar/src/components/CustomTransition.vue
// module id = 1387
// module chunks = 94